import React from 'react';

import type { StudioEntitlements } from 'src/hooks/usePlanStatusHook';
import type { StudioFeature } from 'src/routes/settings/plans/components/studio/studioFeatureGating';

import { StudioUpgradeBadge } from './StudioUpgradeBadge';
import { UpgradeBadge } from './UpgradeBadge';

interface SettingsUpgradeBadgeProps {
  /** Studio entitlements from `usePlanStatus().studio`. */
  studio: StudioEntitlements;
  /** The entitlement-matrix feature this settings section maps to. */
  feature: StudioFeature;
  /**
   * Classic fallback: whether to show the legacy diamond upgrade icon when the
   * workspace is not on Studio pricing. Keeps Classic behavior unchanged.
   */
  legacyShow?: boolean;
}

export const SettingsUpgradeBadge: React.FC<SettingsUpgradeBadgeProps> = ({
  studio,
  feature,
  legacyShow = false,
}) => {
  if (!studio.isStudioPricingWorkspace) {
    return <UpgradeBadge show={legacyShow} />;
  }
  if (studio.isCurrentPlanLoading) {
    return null;
  }
  if (studio.hasFeatureAccess(feature)) {
    return null;
  }
  return <StudioUpgradeBadge />;
};
